import { defineRecipe, defineParts } from "@pandacss/dev";

const parts = defineParts({
  root: {
    selector: '&[data-part="root"]',
  },
  control: {
    selector: '& [data-part="control"]',
  },
  thumb: {
    selector: '& [data-part="thumb"]',
  },
  thumbIndeterminate: {
    selector:
      '& [data-part="control"][data-indeterminate="true"] [data-part="thumb"]',
  },
});

export const aromaToggleSwitch = defineRecipe({
  className: "aroma-toggle-switch",
  jsx: ["ToggleSwitch"],
  base: parts({
    root: {
      display: "flex",
      gap: "gap.2",
      alignItems: "flex-start",
      position: "relative",
      maxWidth: "width.2xl",
    },
    control: {
      display: "flex",
      alignItems: "center",
      width: "xl",
      height: "xs",
      backgroundColor: "background.neutral.base.subtlest",
      borderRadius: "pill",
      padding: "padding.0,5",
      cursor: "pointer",
      position: "relative",
      borderWidth: "m",
      borderStyle: "solid",
      borderColor: "border.neutral.bold",
      transition: "all 0.3s ease-in-out",
      _notDisabled: {
        _checked: {
          backgroundColor: "background.brand.bold",
          borderColor: "transparent",
        },
        _hover: {
          backgroundColor: "background.neutral.base.subtlest-hover",
          borderColor: "border.neutral.bold-hover",
          _checked: {
            backgroundColor: "background.brand.bold-hover",
            borderColor: "transparent",
          },
        },
        _focusVisible: {
          borderColor: "border.brand-bold",
          shadow: "effect.focus-ring.brand",
        },
        '&[data-indeterminate="true"]': {
          backgroundColor: "background.brand.bold",
          borderColor: "background.brand.bold",
          _hover: {
            backgroundColor: "background.brand.bold-hover",
            borderColor: "background.brand.bold-hover",
          },
        },
        _invalid: {
          bgColor: "background.functional.error.subtle",
          borderColor: "border.functional.error",
          _hover: {
            bgColor: "background.functional.error.subtle-hover",
          },
          _checked: {
            bgColor: "background.functional.error.bold",
            borderColor: "background.functional.error.bold",
            _hover: {
              bgColor: "background.functional.error.bold-hover",
            },
          },
          '&[data-indeterminate="true"]': {
            bgColor: "background.functional.error.bold",
            borderColor: "background.functional.error.bold",
          },
          _focusVisible: {
            shadow: "effect.focus-ring.error",
          },
        },
      },
      _disabled: {
        cursor: "not-allowed",
        borderColor: "transparent",
        backgroundColor: "background.neutral.disable.bold",
        _checked: {
          backgroundColor: "background.brand.subtle",
        },
        '&[data-indeterminate="true"]': {
          backgroundColor: "background.brand.subtle",
          borderColor: "background.brand.subtle",
        },
      },
    },
    thumb: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "background.neutral.base.subtle",
      width: "3xs",
      height: "3xs",
      borderRadius: "pill",
      position: "absolute",
      transition: "all 0.3s ease-in-out",
      left: "calc({spacing.padding.1} - {borderWidths.m})",
      _checked: {
        backgroundColor: "background.neutral.base.subtlest",
        width: "2xs",
        height: "2xs",
        color: "content.brand.bold",
        left: "calc(100% - {spacing.padding.0,5} - {sizes.2xs} + {borderWidths.m})",
        "& > i": {
          opacity: "1",
        },
      },
      _hover: {
        backgroundColor: "background.neutral.base.subtle-hover",
        _checked: {
          backgroundColor: "background.neutral.base.subtlest",
          color: "content.brand.bold-hover",
        },
      },
      _disabled: {
        backgroundColor: "background.neutral.disable.subtlest",
        _checked: {
          "& > i": {
            color: "content.brand.subtlest",
          },
        },
      },
      _invalid: {
        bgColor: "background.functional.error.bold",
        color: "content.functional.error",
        _checked: {
          bgColor: "background.neutral.base.subtlest",
          _hover: {
            color: "content.functional.error",
          },
        },
        _hover: {
          bgColor: "background.functional.error.bold-hover",
        },
        '&[data-indeterminate="true"]': {
          bgColor: "background.functional.error.bold",
        },
      },
      "& > i": {
        fontSize: "{sizes.3xs}",
        opacity: "0",
        transition: "opacity 0.3s ease-in-out",
      },
    },
    thumbIndeterminate: {
      left: "calc(50% - {sizes.3xs} / 2)",
      backgroundColor: "content.neutral.reverse.bold",
      height: "2px",
      "& > i": {
        opacity: "0",
      },
      _hover: {
        backgroundColor: "content.neutral.reverse.bold-hover",
      },
      _disabled: {
        backgroundColor: "content.brand.subtle",
      },
    },
  }),
});
